import { apiRequestWithMetadata, type ApiResponseResult } from '@/api/client'
import { orderImagesFeedSchema } from '@/api/orders/schemas'
import type { OrderImagesFeed } from '@/api/orders/types'

const BASE = '/api/order/OrderImages/feed'

export interface OrderFeedRequest {
  readonly orderCount: number
  readonly since: string | null
  readonly etag: string | null
  readonly lastModified: string | null
  readonly signal?: AbortSignal
}

/** Lädt den festen OrderImages-Feed initial oder ab einem Cursor. */
export function fetchOrderFeed(
  request: OrderFeedRequest,
): Promise<ApiResponseResult<OrderImagesFeed>> {
  const conditionalHeaders: Record<string, string> = {}
  if (request.etag !== null) conditionalHeaders['If-None-Match'] = request.etag
  if (request.lastModified !== null) conditionalHeaders['If-Modified-Since'] = request.lastModified

  return apiRequestWithMetadata<OrderImagesFeed>(BASE, {
    query: { orderCount: request.orderCount, since: request.since ?? undefined },
    ...(request.signal === undefined ? {} : { signal: request.signal }),
    ...(Object.keys(conditionalHeaders).length === 0 ? {} : { headers: conditionalHeaders }),
    schema: orderImagesFeedSchema,
  })
}
